import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import moment from 'moment';

/* Components and Hooks */
import useDetectMobile from '../../hooks/useDetectMobile';

/* Styles */
import 'react-datepicker/dist/react-datepicker.css';
import './styles.scss';

const FormikDateOfBirth = ({
  value,
  id,
  setFieldValue,
  inputClassName,
  ...otherProps
}) => {
  const mobileType = useDetectMobile();

  const baseInput = (
    <input id={id} value={value} className={inputClassName} {...otherProps} />
  );

  if (mobileType === 'iOS') {
    /* Use iOS default date picker */
    return baseInput;
  }

  const { onBlur } = otherProps;

  const updateCalendarValue = val => {
    if (!val) return setFieldValue(id, null);
    const newSelectedDate = moment(val).format('YYYY-MM-DD');

    return setFieldValue(id, newSelectedDate);
  };

  const selectedDate = (value && moment(value).toDate()) || null;

  /* Return portalled on phone to avoid selection issues */
  if (mobileType === 'android') {
    return (
      <DatePicker
        calendarClassName="portalled-calendar"
        className={inputClassName}
        customInput={baseInput}
        dateFormat="yyyy-MM-dd"
        dropdownMode="select"
        id={id}
        onBlur={onBlur}
        onChange={updateCalendarValue}
        placeholderText="yyyy-mm-dd"
        selected={selectedDate}
        showYearDropdown
        withPortal
      />
    );
  }

  /* Default */
  return (
    <DatePicker
      className={inputClassName}
      dateFormat="yyyy-MM-dd"
      dropdownMode="select"
      id={id}
      onBlur={onBlur}
      onChange={updateCalendarValue}
      placeholderText="yyyy-mm-dd"
      popperPlacement="auto"
      scrollableYearDropdown
      selected={selectedDate}
      showYearDropdown
    />
  );
};

FormikDateOfBirth.propTypes = {
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  id: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func,
  inputClassName: PropTypes.string,
  type: PropTypes.string
};

FormikDateOfBirth.defaultProps = {
  value: null,
  setFieldValue: null,
  inputClassName: '',
  type: ''
};

export default FormikDateOfBirth;
